import React, {FC} from 'react';
import TransferRoute from '../../transfers/types/TransferRoute';
import Transfer from '../../transfers/types/Transfer';
import {TransferCommonDescription} from "../../transfers/types/TransferCommonDescription";
import useTranslate from "../../core/languages/hooks/useTranslate";
import TransferItemCard from "./TransferItemCard";
import TransportLocation from "../../transfers/types/TransportLocation";
import TitleCardSection from "./TitleCardSection";

interface TransferDetailsSectionProps {
  transferInfo: Transfer;
  locationFrom?: TransportLocation;
  locationTo?: TransportLocation;
  parentTransfer?: TransferCommonDescription;
  route?: TransferRoute;
}

const TransferDetailsSection: FC<TransferDetailsSectionProps> = ({
                                                                   transferInfo,
                                                                   locationFrom,
                                                                   locationTo,
                                                                   parentTransfer,
                                                                   route
                                                                 }) => {
  const t = useTranslate();

  return (
    <div className="flex flex-col space-y-4 mb-10">
        <TitleCardSection
            title={t("transferOk.message.transferDetails")}
            subtitle={t("transferOk.message.transferDetailsSubtitle")}
        />
      <div
        className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
        <TransferItemCard transfer={transferInfo} locationFrom={locationFrom} locationTo={locationTo}
                          parentTransfer={parentTransfer} route={route}/>
      </div>
    </div>
  );
};

export default TransferDetailsSection;

